import { useLoaderData, useParams } from "@tanstack/react-router";
import { ThemeProvider } from "next-themes";
import { NuqsAdapter } from "nuqs/adapters/tanstack-router";
import type { FC, PropsWithChildren } from "react";
import { IntlProvider } from "use-intl";
import { APPEARANCE_THEMES } from "$/modules/shared/hooks/useAppearance";
import { AppearanceSync } from "$/modules/shared/provider/appearance-sync";
import { QueryProvider } from "$/modules/shared/provider/query-provider";
import { Toaster } from "$/modules/shared/ui/sonner";

export const ProviderCollection: FC<PropsWithChildren> = ({ children }) => {
	const { locale } = useParams({ from: "/$locale" });
	const loaderData = useLoaderData({ from: "/$locale" });

	const messages = loaderData?.messages || {};

	return (
		<IntlProvider
			locale={locale}
			messages={messages}
			onError={(error) => {
				if (error.code === "MISSING_MESSAGE") {
					console.warn("Missing translation:", error.message);
				}
			}}
		>
			<QueryProvider>
				<NuqsAdapter>
					<ThemeProvider
						attribute="class"
						defaultTheme="playful-light"
						enableSystem={false}
						enableColorScheme={false}
						themes={[...APPEARANCE_THEMES]}
						disableTransitionOnChange
					>
						<AppearanceSync />
						<main className="min-h-screen text-foreground bg-background">
							{children}
						</main>
						<Toaster richColors />
					</ThemeProvider>
				</NuqsAdapter>
			</QueryProvider>
		</IntlProvider>
	);
};
